import React from 'react';
export function ProductIntro() {
  return <section className="bg-brand-dark py-4 px-5" data-id="element-253">
      <div className="max-w-md mx-auto text-center" data-id="element-254">
        <div className="bg-gray-900/50 border-2 border-brand-yellow/30 rounded-3xl p-6 md:p-8 shadow-[0_0_50px_-12px_rgba(251,191,36,0.1)]" data-id="element-255">
          <h2 className="text-xl md:text-2xl font-black text-white mb-3 leading-tight" data-id="element-256">
            📚 MegaPack Planificación <br className="hidden md:block" data-id="element-257" />
            <span className="text-brand-yellow" data-id="element-258">Docente Lista™</span>
          </h2>

          <div className="space-y-4 text-[16px] font-[400]" data-id="element-259">
            <p className="text-gray-300 font-medium text-[14px]" data-id="element-260">
              Un sistema completo que te dice:
            </p>

            <div className="flex flex-col gap-3 max-w-xs mx-auto" data-id="element-261">
              {[{
              emoji: '👉',
              text: 'Qué hacer',
              highlight: 'text-white'
            }, {
              emoji: '👉',
              text: 'Cómo hacerlo',
              highlight: 'text-white'
            }, {
              emoji: '👉',
              text: 'Cuándo usarlo',
              highlight: 'text-white'
            }].map((item, i) => <div key={i} className="flex items-center gap-3 bg-gray-800/50 p-3 rounded-2xl border border-gray-700/50 hover:border-brand-yellow/50 transition-colors group text-[14px]" data-id="element-262">
                  <span className="text-xl group-hover:scale-110 transition-transform" data-id="element-263">
                    {item.emoji}
                  </span>
                  <span className={`text-base font-bold ${item.highlight}`} data-id="element-264">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}